import axios from 'axios';

export default {
  install(app) {
    app.mixin({
      methods: {
        $proxyCheck() {
          if (!this.setbrandid) return;
          
          const data = { brand_id: this.setbrandid };
          
          axios.post(
            "https://api.rezcomm.com/srchana/iplatlon",
            data,
            {
              headers: {
                secret_id: 'ed6a467528707c07fad1540f4820cc2a',
                secret_key: '429cc1c9a706d77fa23c5aa82cf2b30d357e4c02f4522f09',
                "Content-Type": "application/json",
              },
            }
          ).then((response) => {
            const response_data = JSON.parse(response.request.response);
            if (response_data) {
              const { anonymous = "false", proxy = "false", vpn = "false", tor = "false" } = response_data;
              if (anonymous === "true" || proxy === "true" || vpn === "true" || tor === "true") {
                window.location.href = "/proxycheck.html";
              }
            }
          });
        }
      }
    });
  }
};
